import axios from '@/plugins/api.request'

/**
 * 用户登录
 * @param {*} data
 */
export const login = (data) => {
  return axios.request({
    method: 'post',
    url: 'user/login',
    data
  })
}

/**
 * 用户注册
 * @param {*} data
 */
export const register = (data) => {
  return axios.request({
    method: 'post',
    url: 'user/register',
    data
  })
}

/**
 * 获取用户信息
 * @param {*} data 
 */
export const getProfile = (params) => {
  return axios.request({
    method: 'get',
    url: 'user/getProfile',
    params
  })
}

/**
 * 更新用户信息
 * @param {*} data 
 */
export const updateProfile = (data) => {
  return axios.request({
    method: 'post',
    url: 'user/updateProfile',
    data
  })
}

/**
 * 搜索用户
 * @param {*} data
 */
export const searchUser = (params) => {
  return axios.request({
    method: 'get',
    url: 'user/searchByUsername',
    params
  })
}

/**
 * 修改密码
 * @param {*} data
 */
export const resetPassword = (data) => {
  return axios.request({
    method: 'post',
    url: 'user/resetPassword',
    data
  })
}

/**
 * 获取角色
 * @param {*} params
 */
export const getEduRole = (params) => {
  return axios.request({
    method: 'get',
    url: 'user/getEduRole',
    params
  })
}

/**
 * 设置角色
 * @param {*} param
 */
export const setEduRole = (params) => {
  return axios.request({
    method: 'get',
    url: 'user/setEduRole',
    params
  })
}

/**
 * 更新token
 * @param {*} param
 */
 export const refreshToken = (params) => {
  return axios.request({
    method: 'get',
    url: 'user/refreshToken',
    params
  })
}